export default {
  bindings: {
    gateway: '<',
    errorCallback: '&',
    successCallback: '&',
    paymentConfig: '<'
  },
  controller: 'paymentRequestButtonController',
  template: require('../views/payment.requestButton.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/components/payment.requestButton.component.js